module.exports = __webpack_public_path__ + "img/15.94dac999.jpg";